import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 報名流程
  {
    path: '/product/brand/:brandAlias/event/:eventAlias/:eventSeriesNum/apply',
    name: 'event-apply',
    component: () => lazyLoadView(import('@views/Apply/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            }),
          ]);
          const [
            currentMember,
            currentCart
          ] = await Promise.all([
            store.dispatch('auth/fetchUser'),
            store.dispatch('cart/fetchCart'),
          ]);

          const isCartNull = !currentCart.items[0];

          if(isCartNull) {
            alert('您還沒選擇想報名的課程活動 \n 系統將重新導向至課程活動頁面');

            return next({ name: 'event-list' });
          } else {
            routeTo.params.cartItem = currentCart.items[0];
          }

          // routeTo.params.breadcrumbTitle = `報名: ${currentCart.items[0].title}`;
          routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;
          routeTo.params.breadcrumbLevel5Title = currentCart.items[0].title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '報名流程'
    },
    props: (route) => ({
      cartItem: route.params.cartItem || {},
    })
  },
  // 報名完成
  {
    path: '/product/brand/:brandAlias/event/:eventAlias/:eventSeriesNum/:uuid',
    name: 'event-apply-detail',
    component: () => lazyLoadView(import('@views/Apply/Detail')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: routeTo.params.brandAlias
            }),
            store.dispatch('auth/fetchUser'),
          ]);
          const [
            currentOrder,
          ] = await Promise.all([
            store.dispatch('order/fetchApplyOrderItem', {
              uuid: routeTo.params.uuid
            }),
          ]);

          // routeTo.params.breadcrumbTitle = `報名完成: ${currentOrder.items.title}`;
          // routeTo.params.breadcrumbLevel2Title = currentOrder.items.title;
          routeTo.params.breadcrumbLevel3Title =  store.state.brand.cachedBrand.title;
          routeTo.params.breadcrumbLevel5Title = currentOrder.title;
          routeTo.params.orderItem = currentOrder;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isLoginPage: true,
      title: '報名完成'
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {}
    })
  },
]
